/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Benefits_TitleInputs */

const en_home_benefits_title = /** @type {(inputs: Home_Benefits_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`More Than Travel Insurance`)
};

const fr_home_benefits_title = /** @type {(inputs: Home_Benefits_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus que de l'assurance voyage`)
};

/**
* | output |
* | --- |
* | "More Than Travel Insurance" |
*
* @param {Home_Benefits_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_benefits_title = /** @type {((inputs?: Home_Benefits_TitleInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Benefits_TitleInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_benefits_title(inputs)
	return fr_home_benefits_title(inputs)
});